export const isAuthenticated = state => state.auth.token !== null;
export const getToken = state => state.auth.token;
export const getUserInfo = state => state?.auth?.userInfo || null;
export const getConfig = state => state.config;
export const getErrors = state => state.errors;
export const getSuccessMessages = state => state.successMessages;
export const isSecondary = state => state.auth?.userInfo?.type === 'Secondary';
export const isService = state => state.auth?.userInfo?.type === 'Service';

// Selectors related to the config read from the GitLab CI variables.
// They include null checks to ensure that components which use them don't fail to load due to missing config.
export const getWsDbSiteManagementLink = state => state.config?.links.wsDbSiteMgmt;
export const getAppCatalogueSiteManagementLink = state => state.config?.links.appCatalogueSiteMgmt;
export const getPaaSSiteManagementLink = state => state.config?.links.paasSiteMgmt;
export const getCernBoxPersonalLink = state => state.config?.links.cernBoxPersonal;
export const getCernBoxProjectLink = state => state.config?.links.cernBoxProject;
export const getWebeosSiteLogsLink = state => state.config?.logs.webeosSite;
export const getMatomoInstanceLink = state => state.config?.links.matomoServer;
export const getShortURLHosts = state => state.config?.shortUrlHosts;
export const getBannerText = state => state.config?.bannerText;
